import { TwiggsMF as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { period } = options;

    if (data.length < period + 1) {
      return [];
    }

    const results = [];
    let sumMoneyFlow = 0;
    let sumVolume = 0;
    const decayFactor = (period - 1) / period;

    for (let i = 0; i < data.length; i++) {
      // First bar needs previous close, so always undefined
      if (i < 1) {
        results.push(undefined);
        continue;
      }

      const current = data[i];
      const previous = data[i - 1];

      if (!current || !previous) {
        results.push(undefined);
        continue;
      }

      // Extract volume (can be object or number)
      let vol = current.volume;
      if (typeof vol === "object" && vol !== null) {
        vol = vol.volume;
      }

      // Calculate True Range High and Low
      const trh = Math.max(previous.close, current.high);
      const trl = Math.min(previous.close, current.low);
      const range = trh - trl;

      // Calculate Money Flow Volume
      let mfv = 0;
      if (range !== 0 && vol) {
        mfv =
          (vol * (2 * current.close - trh - trl)) /
          (range === 0 ? 999999 : range);
      }

      // Apply exponential smoothing after initial period
      if (i > period - 1) {
        sumMoneyFlow *= decayFactor;
        sumVolume *= decayFactor;
      }

      sumMoneyFlow += mfv;
      sumVolume += vol || 0;

      // Calculate Twiggs MF after initial period
      if (i > period - 1) {
        const twiggsMF = sumVolume > 0 ? sumMoneyFlow / sumVolume : 0;
        results.push(twiggsMF);
      } else {
        results.push(undefined);
      }
    }

    return results;
  }

  calculator.undefinedLength = function () {
    return options.period;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
